import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NavbarComponent } from '@components/navbar/navbar.component';
import { ButtonComponent } from '@components/button/button.component';
import { ChooseLanguageComponent } from '@components/choose-language/choose-language.component';
import { ClockComponent } from '@components/clock/clock.component';
import { ButtonLanguagesComponent } from '@components/button-languages/button-languages.component';
import { LanguagesModalComponent } from '@modals/languages-modal/languages-modal.component';
import { FinderpnrModalComponent } from '@modals/finderpnr-modal/finderpnr-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { AmFooterComponent } from '@components/am-footer/am-footer.component';
import { AmKeyboardComponent } from '@components/am-keyboard/am-keyboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AmKeyComponent } from '@components/am-keyboard/am-key/am-key.component';
import { AmLoadingComponent } from '@components/am-loading/am-loading.component';
import { AmKeyboardDirective } from '@components/am-keyboard/am-keyboard.directive';
import { AmInactiveDirective } from '@directives/am-inactive.directive';
import { AmKioskPermissionDirective } from '@directives/am-kiosk-permission.directive';
import { AmSeatCircleComponent } from '@components/am-seat-circle/am-seat-circle.component';
import { WaitModalComponent } from '@modals/wait-modal/wait-modal.component';
import {
  AMPMPipe,
  HourTo24FromAMPMDatePipe,
  LocalizedDatePipe,
  LoyaltyProgramsPipe,
  MaskProtectNumberPipe,
  SeatUbicationPipe,
} from '@pipes/loyalty-programs.pipe';
import { NameInitialsPipe, ShortUUIDPipe } from '@pipes/short-uuid.pipe';
import { AmShowVideoComponent } from '@components/am-show-video/am-show-video.component';
import { NgbDatepicker, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AmScrollComponent } from '@components/am-scroll/am-scroll.component';
import { AmCounterComponent } from '@components/am-bags-table-components/am-counter/am-counter.component';
import { AmBagsBannerComponent } from '@components/am-bags-banner/am-bags-banner.component';
import { AmBagsTableComponent } from '@components/am-bags-table-components/am-bags-table/am-bags-table.component';
import { AmBagsPassengerComponent } from '@components/am-bags-table-components/am-bags-passenger/am-bags-passenger.component';
import { AlertPremierDisclaimerComponent } from '@modals/alert-premier-disclaimer/alert-premier-disclaimer.component';
import { ScanpassportModalComponent } from '@modals/scanpassport-modal/scanpassport-modal.component';
import { SelectModalComponent } from '@modals/select-modal/select-modal.component';
import { IconFormCorrectComponent } from '@components/icon-form-correct/icon-form-correct.component';
import { PhoneInputComponent } from '@components/phone-input/phone-input.component';
import { AmBagsPaymentComponent } from '@components/am-bags-table-components/am-bags-payment/am-bags-payment.component';
import { AmBagsFooterCountBagsComponent } from '@components/am-bags-table-components/am-bags-footer-count-bags/am-bags-footer-count-bags.component';
import { AmBagStatusComponent } from '@components/am-bags-table-components/am-bag-status/am-bag-status.component';
import { AmImageComponent } from '@components/am-image/am-image.component';
import { AmBagRedeemedComponent } from '@components/am-bags-table-components/am-bag-redeemed/am-bag-redeemed.component';
import { AmBagsTableCarryonComponent } from '@components/am-bags-table-components/am-bags-table-carryon/am-bags-table-carryon.component';
import { AmBagDetailCarryonComponent } from '@components/am-bags-table-components/am-bag-detail-carryon/am-bag-detail-carryon.component';
import { AmBagPriceCarryonComponent } from '@components/am-bags-table-components/am-bag-price-carryon/am-bag-price-carryon.component';
import { AmBagAddCarryonComponent } from '@components/am-bags-table-components/am-bag-add-carryon/am-bag-add-carryon.component';
import { AmCheckBoxComponent } from '@components/am-check-box/am-check-box.component';
import { AmBagsFooterResumeComponent } from '@components/am-bags-table-components/am-bags-footer-resume/am-bags-footer-resume.component';
import { Bags20kgOnlyWebAppModalComponent } from '@modals/bags-20kg-only-web-app-modal/bags-20kg-only-web-app-modal.component';
import { AmStatusPaymentComponent } from '@components/am-status-payment/am-status-payment.component';
import { modalRefactorComponent } from '@modals/modal-refactor/modal-refactor.component';
import { FormErrorMessageComponent } from '@components/form-error-message/form-error-message.component';
import { AmInputFormComponent } from '@components/am-input-form/am-input-form.component';
import { AmSelectFormComponent } from '@components/am-select-form/am-select-form.component';
import { AmDateFormComponent } from '@components/am-date-form/am-date-form.component';
import { FlightStatusAlertComponent } from '@components/srIrops/flight-status-alert/flight-status-alert.component';
import { TitleIropsViewComponent } from '@components/srIrops/title-irops-view/title-irops-view.component';
import { SubtitleIropsViewComponent } from '@components/srIrops/subtitle-irops-view/subtitle-irops-view.component';
import { AmpassengerButtonSelectComponent } from '@components/ampassenger-button-select/ampassenger-button-select.component';
import { NewFlightInfoIropsViewComponent } from '@components/srIrops/new-flight-info-irops-view/new-flight-info-irops-view.component';
import { ItineraryAfectedIropsViewComponent } from '@components/srIrops/itinerary-afected-irops-view/itinerary-afected-irops-view.component';
import { ItineraryCanceledIropsViewComponent } from '@components/srIrops/itinerary-canceled-irops-view/itinerary-canceled-irops-view.component';
import { BannerIropsViewComponent } from '@components/srIrops/banner-irops-view/banner-irops-view.component';
import { ErrorsModalComponent } from '@modals/errors/errors-modal/errors-modal.component';
import { ErrorsModalDestinationComponent } from '@modals/errors/errors-modal-destination/errors-modal-destination.component';
import { IropsAfectedNoKioskComponent } from '@modals/irops-afected-no-kiosk/irops-afected-no-kiosk.component';
import { AmFlightInfoBannerComponent } from '@components/am-flight-info-banner/am-flight-info-banner.component';
import { AmRowPlaneComponent } from '@components/am_plane_config/am-row-plane/am-row-plane.component';
import { AmSeatPlaneComponent } from '@components/am_plane_config/am-seat-plane/am-seat-plane.component';
import { AmMapPlaneComponent } from '@components/am_plane_config/am-map-plane/am-map-plane.component';
import { AmFlightItineraryComponent } from '@components/am-flight-itinerary/am-flight-itinerary.component';
import { AmScrollDirective } from '@app/directives/am-scroll-directive';
import { AmCalendarComponent } from '@modals/am-calendar/am-calendar.component';
import { AmCalendarItemComponent } from '@components/am-calendar/am-calendar-item/am-calendar-item.component';
import { AmCalendarMonthComponent } from '@components/am-calendar/am-calendar-month/am-calendar-month.component';
import { MagnifyVideoModalComponent } from '@modals/magnify-video-modal/magnify-video-modal.component';
import { AmFlightStatusPipe } from '@pipes/am-flight-status.pipe';
import { AMCapitalizePipe } from '@pipes/capitalize.pipe';
import { BannerIropsFlightInfoComponent } from '@components/banner-irops-flight-info/banner-irops-flight-info.component';
import { AmButtonCalendarComponent } from '@components/am-button-calendar/am-button-calendar.component';
import { ModalNoticeCanadaComponent } from '@modals/modal-canada/modal-canada.component';
import { FlightDetailModalComponent } from '@modals/flight-detail-modal/flight-detail-modal.component';
import { IropReviewItineraryComponent } from '@components/srIrops/irop-review-itinerary/irop-review-itinerary.component';
import { AmFlightSelectItineraryComponent } from '@components/am-flight-select-itinerary/am-flight-select-itinerary.component';
import { AmInputGlobalFormComponent } from '@components/am-input-global-form/am-input-global-form.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { TitleFormAlertComponent } from '@components/title-form-alert/title-form-alert.component';
import { AmLabelComponent } from '@components/am-label/am-label.component';
import { AmInputSwitchComponent } from '@components/am-input-switch/am-input-switch.component';
import { VisaModalComponent } from '@modals/visa-modal/visa-modal.component';
import { AirLinesComponent } from '@modals/air-lines/air-lines.component';
import { BannerExclamationComponent } from '@components/am-banner-exclamation/am-banner-exclamation.component';
import { ApplyAllPassengersComponent } from '@components/apply-all-passengers/apply-all-passengers.component';
import { AmWarningCheckInComponent } from '@components/am-warning-check-in/am-warning-check-in.component';
import { AmLegFlightComponent } from '@components/am-leg-flight/am-leg-flight.component';
import { AmItineraryLegComponent } from '@components/am-itinerary-leg/am-itinerary-leg.component';
import { AmGenderPipe } from '@pipes/am-gender.pipe';
import { AmBannerCorporateComponent } from '@components/am-banner-corporate/am-banner-corporate.component';
import { AmStatusBannerComponent } from '@components/am-status-banner/am-status-banner.component';
import { AmFlightStatusScreenComponent } from '@components/am-flight-status-screen/am-flight-status-screen.component';
import { ModalFullLoadingComponent } from '@modals/modal-full-loading/modal-full-loading.component';
import { OfflineConnectivityModalComponent } from '@modals/offline-connectivity-modal/offline-connectivity-modal.component';
import { AmBagsCounterComponent } from './components/am-bags-counter/am-bags-counter.component';
import { ReprintModalComponent } from '@modals/reprint-modal/reprint-modal.component';
import { StepperBagsComponent } from './components/stepper-bags/stepper-bags.component';
import { WeighingComponent } from './components/weighing/weighing.component';
import { WeighingSSBDComponent } from './components/weighing-ssbd/weighing-ssbd.component';
import { AmpassengerButtonSelectBagsComponent } from '@components/ampassenger-button-select-bags/ampassenger-button-select-bags.component';
import { AmTruncatePipe } from '@pipes/am-truncate.pipe';
import { ErrorsModalCknComponent } from '@modals/errors/errors-modal-ckn/errors-modal-ckn.component';
import { VenezuelaModalComponent } from '@modals/venezuela-modal/venezuela-modal.component';
import { SeatBenefitsModalComponent } from '@modals/seat-benefits-modal/seat-benefits-modal.component';
import { AmActionsMenuComponent } from '@components/am-actions-menu/am-actions-menu.component';
import { AmCartItemComponent } from '@components/am-cart-item/am-cart-item.component';
import { VerifyPassportModalComponent } from '@modals/verify-passport-modal/verify-passport-modal.component';
import { AmQrcodeComponent } from '@components/am-qrcode/am-qrcode.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { ModalPassengersPriorityCodeComponent } from './modals/modal-passengers-priority-code/modal-passengers-priority-code.component';
import { AmPassengerListPriorityCodeComponent } from './components/am-passenger-list-priority-code/am-passenger-list-priority-code.component';
import { AmPassengerListPriorityCodeItemComponent } from './components/am-passenger-list-priority-code-item/am-passenger-list-priority-code-item.component';
import { DownloadAppModalComponent } from './modals/download-app-modal/download-app-modal.component';
import { NeedChairModalComponent } from './modals/need-chair-modal/need-chair-modal.component';
import { AmpassengerButtonSelectFnnComponent } from './components/ampassenger-button-select-fnn/ampassenger-button-select-fnn.component';
import { TitleIropsRebrandComponent } from './components/srIrops/title-irops-rebrand/title-irops-rebrand.component';
import { FlightStatusAlertRebrandComponent } from './components/srIrops/flight-status-alert-rebrand/flight-status-alert-rebrand.component';
import { SubtitleIropsRebrandComponent } from './components/srIrops/subtitle-irops-rebrand/subtitle-irops-rebrand.component';
import { NewFlightInfoIropsRebrandComponent } from './components/srIrops/new-flight-info-irops-rebrand/new-flight-info-irops-rebrand.component';
import { ItineraryCanceledIropsRebrandComponent } from './components/srIrops/itinerary-canceled-irops-rebrand/itinerary-canceled-irops-rebrand.component';
import { BannerIropsRebrandComponent } from './components/srIrops/banner-irops-rebrand/banner-irops-rebrand.component';
import { ItineraryDelayedIropsRebrandComponent } from './components/srIrops/itinerary-delayed-irops-rebrand/itinerary-delayed-irops-rebrand.component';
import { ItineraryEarlyIropsRebrandComponent } from './components/srIrops/itinerary-early-irops-rebrand/itinerary-early-irops-rebrand.component';
import { IropsDeleteCHKModalComponent } from './modals/irops-delete-chk-modal/irops-delete-chk-modal.component';
import { NotFoundFlightComponent } from './modals/not-found-flight/not-found-flight.component';
import { QrRefundFlightComponent } from './modals/qr-refund-flight/qr-refund-flight.component';
import { FlightDataInfoComponent } from './components/srIrops/flight-data-info/flight-data-info.component';
import { ItineraryNoElegibleComponent } from './components/srIrops/itinerary-no-elegible/itinerary-no-elegible.component';
import { BannerNoElegibleComponent } from './components/srIrops/banner-no-elegible/banner-no-elegible.component';
import { ValidHourUndefinedPipe } from '@app/pipes/valid-hour-undefined.pipe';
import { BannerConfirmedFlightAfectedComponent } from '@components/srIrops/banner-confirmed-flight-afected/banner-confirmed-flight-afected.component';
import { BagsRedemptionModalComponent } from './modals/bags-redemption-modal/bags-redemption-modal.component';
import { BagsBenefitModalComponent } from './modals/bags-benefit-modal/bags-benefit-modal.component';
import { BagsBenefitErrorModalComponent } from './modals/bags-benefit-error-modal/bags-benefit-error-modal.component';
import { AmPassengerCellCarryOnComponent } from './components/am-bags-carryon/am-passenger-cell-carryOn/am-passenger-cell-carryOn.component';
import { AmBagCellCarryOnComponent } from './components/am-bags-carryon/am-bag-cell-carryOn/am-bag-cell-carryOn.component';
import { CarryonOfferModalComponent } from './modals/carryon-offer-modal/carryon-offer-modal.component';
import { CarryonAddModalComponent } from './modals/carryon-add-modal/carryon-add-modal.component';
import { TsaBlockerModalComponent } from './modals/tsa-blocker-modal/tsa-blocker-modal.component';
import { AmPlaneFareInfoComponent } from './components/am_plane_config/am-plane-fare-info/am-plane-fare-info.component';
import { ErrorReciptComponent } from './modals/errors/error-recipt/error-recipt.component';
import { PrinterErrorModalComponent } from '@modals/printerError-modal/printerError-modal.component';
import { BagtagLowPaperModalComponent } from '@modals/bagtag-low-paper-modal/bagtag-low-paper-modal.component';
import { BoardingPassLowPaperModalComponent } from '@modals/boardingpass-low-paper-modal/boardingpass-low-paper-modal.component';
import { BoardingPassPaperEmptyModalComponent } from '@modals/boardingpass-paper-empty-modal/boardingpass-paper-empty-modal.component';
import { PaymentSimulatorModalComponent } from './modals/payment-simulator-modal/payment-simulator-modal.component';
import { PaymentSimulatorAdminComponent } from './components/payment-simulator-admin/payment-simulator-admin.component';
import { PlacesAutocompleteComponent } from './components/places-autocomplete/places-autocomplete.component';
import { SearchInputComponent } from './components/places-autocomplete/ui/search-input/search-input.component';
import { ResultListComponent } from './components/places-autocomplete/ui/result-list/result-list.component';
import { ScrollControlsComponent } from './components/places-autocomplete/ui/scroll-controls/scroll-controls.component';
import { HighlightTextPipe } from '@app/pipes/highlight-text.pipe';
import { EligibilityMessageComponent } from './components/eligibility-message/eligibility-message.component';
import { BaggageTimerComponent } from './components/baggage-timer/baggage-timer.component';
import { StepperBagsSsbdComponent } from './components/stepper-bags-ssbd/stepper-bags-ssbd.component';
import { AmToastComponent } from './components/am-toast/am-toast.component';
import { CobrandBenefitModalComponent } from './modals/cobrand-benefit-modal/cobrand-benefit-modal.component';
import { AmExperiencePollComponent } from './components/am-experience-poll/am-experience-poll.component';
import { ExperiencePollModalComponent } from './modals/experience-poll-modal/experience-poll-modal.component';
import { AmCurrencyPipe } from '@pipes/am-currency.pipe';

@NgModule({
  declarations: [
    NavbarComponent,
    ButtonComponent,
    ChooseLanguageComponent,
    ClockComponent,
    ButtonLanguagesComponent,
    LanguagesModalComponent,
    FinderpnrModalComponent,
    AmKeyboardComponent,
    AmKeyComponent,
    AmFooterComponent,
    AmKeyboardDirective,
    AmLoadingComponent,
    AmInactiveDirective,
    AmKioskPermissionDirective,
    AmSeatCircleComponent,
    AmQrcodeComponent,
    WaitModalComponent,
    LoyaltyProgramsPipe,
    ShortUUIDPipe,
    AmShowVideoComponent,
    AmScrollComponent,
    AmCounterComponent,
    AmBagsBannerComponent,
    AmBagsPassengerComponent,
    AmBagsTableComponent,
    AlertPremierDisclaimerComponent,
    ScanpassportModalComponent,
    VenezuelaModalComponent,
    SeatBenefitsModalComponent,
    SelectModalComponent,
    PhoneInputComponent,
    IconFormCorrectComponent,
    IconFormCorrectComponent,
    SelectModalComponent,
    AmBagsPaymentComponent,
    AmBagsFooterCountBagsComponent,
    AmBagStatusComponent,
    AmBagRedeemedComponent,
    AmImageComponent,
    AMPMPipe,
    HourTo24FromAMPMDatePipe,
    AmBagsTableCarryonComponent,
    AmBagDetailCarryonComponent,
    AmBagPriceCarryonComponent,
    AmBagAddCarryonComponent,
    AmCheckBoxComponent,
    AmBagsFooterResumeComponent,
    Bags20kgOnlyWebAppModalComponent,
    modalRefactorComponent,
    AmStatusPaymentComponent,
    FormErrorMessageComponent,
    AmInputFormComponent,
    AmSelectFormComponent,
    AmDateFormComponent,
    FlightStatusAlertComponent,
    ItineraryAfectedIropsViewComponent,
    ItineraryCanceledIropsViewComponent,
    SubtitleIropsViewComponent,
    TitleIropsViewComponent,
    BannerIropsViewComponent,
    ErrorsModalComponent,
    ErrorsModalDestinationComponent,
    ErrorsModalCknComponent,
    VerifyPassportModalComponent,
    AmpassengerButtonSelectComponent,
    NewFlightInfoIropsViewComponent,
    TitleIropsViewComponent,
    BannerIropsViewComponent,
    IropsAfectedNoKioskComponent,
    AmFlightInfoBannerComponent,
    AmRowPlaneComponent,
    AmSeatPlaneComponent,
    AmMapPlaneComponent,
    AmFlightItineraryComponent,
    AmScrollDirective,
    AmCalendarComponent,
    AmCalendarItemComponent,
    AmCalendarMonthComponent,
    MagnifyVideoModalComponent,
    LocalizedDatePipe,
    AmFlightStatusPipe,
    AMCapitalizePipe,
    BannerIropsFlightInfoComponent,
    AmButtonCalendarComponent,
    ModalNoticeCanadaComponent,
    IropReviewItineraryComponent,
    FlightDetailModalComponent,
    SeatUbicationPipe,
    NameInitialsPipe,
    AmFlightSelectItineraryComponent,
    AmInputGlobalFormComponent,
    TitleFormAlertComponent,
    AmLabelComponent,
    AmInputSwitchComponent,
    VisaModalComponent,
    AirLinesComponent,
    BannerExclamationComponent,
    ApplyAllPassengersComponent,
    MaskProtectNumberPipe,
    AmWarningCheckInComponent,
    AmLegFlightComponent,
    AmItineraryLegComponent,
    AmGenderPipe,
    ModalFullLoadingComponent,
    OfflineConnectivityModalComponent,
    AmBagsCounterComponent,
    AmBannerCorporateComponent,
    AmStatusBannerComponent,
    AmFlightStatusScreenComponent,
    AmItineraryLegComponent,
    ReprintModalComponent,
    AmTruncatePipe,
    WeighingComponent,
    WeighingSSBDComponent,
    StepperBagsComponent,
    AmTruncatePipe,
    AmpassengerButtonSelectBagsComponent,
    NeedChairModalComponent,
    AmpassengerButtonSelectFnnComponent,
    AmActionsMenuComponent,
    AmCartItemComponent,
    BagsRedemptionModalComponent,
    BagsBenefitModalComponent,
    BagsBenefitErrorModalComponent,
    ModalPassengersPriorityCodeComponent,
    AmPassengerListPriorityCodeComponent,
    AmPassengerListPriorityCodeItemComponent,
    DownloadAppModalComponent,
    FlightStatusAlertRebrandComponent,
    TitleIropsRebrandComponent,
    SubtitleIropsRebrandComponent,
    NewFlightInfoIropsRebrandComponent,
    ItineraryCanceledIropsRebrandComponent,
    ItineraryDelayedIropsRebrandComponent,
    ItineraryEarlyIropsRebrandComponent,
    BannerIropsRebrandComponent,
    IropsDeleteCHKModalComponent,
    NotFoundFlightComponent,
    QrRefundFlightComponent,
    FlightDataInfoComponent,
    ItineraryNoElegibleComponent,
    BannerNoElegibleComponent,
    AmPassengerCellCarryOnComponent,
    AmBagCellCarryOnComponent,
    CarryonOfferModalComponent,
    CarryonAddModalComponent,
    TsaBlockerModalComponent,
    AmPlaneFareInfoComponent,
    ValidHourUndefinedPipe,
    BannerConfirmedFlightAfectedComponent,
    ErrorReciptComponent,
    PrinterErrorModalComponent,
    BagtagLowPaperModalComponent,
    BoardingPassLowPaperModalComponent,
    BoardingPassPaperEmptyModalComponent,
    PaymentSimulatorModalComponent,
    PaymentSimulatorAdminComponent,
    TsaBlockerModalComponent,
    EligibilityMessageComponent,
    PlacesAutocompleteComponent,
    SearchInputComponent,
    ResultListComponent,
    ScrollControlsComponent,
    HighlightTextPipe,
    TsaBlockerModalComponent,
    EligibilityMessageComponent,
    BaggageTimerComponent,
    StepperBagsSsbdComponent,
    AmToastComponent,
    CobrandBenefitModalComponent,
    AmExperiencePollComponent,
    ExperiencePollModalComponent,
    StepperBagsSsbdComponent,
    AmCurrencyPipe
  ],
  exports: [
    NavbarComponent,
    ButtonComponent,
    ChooseLanguageComponent,
    ClockComponent,
    ButtonLanguagesComponent,
    FinderpnrModalComponent,
    TranslateModule,
    AmKeyboardComponent,
    AmKeyComponent,
    AmFooterComponent,
    FormsModule,
    ReactiveFormsModule,
    AmLoadingComponent,
    AmSeatCircleComponent,
    AmQrcodeComponent,
    AmCounterComponent,
    AmBagsBannerComponent,
    WaitModalComponent,
    AmKeyboardDirective,
    AmInactiveDirective,
    AmKioskPermissionDirective,
    LoyaltyProgramsPipe,
    ShortUUIDPipe,
    FormsModule,
    ReactiveFormsModule,
    AmShowVideoComponent,
    AmBagsTableComponent,
    AmScrollComponent,
    AmBagsPassengerComponent,
    PhoneInputComponent,
    IconFormCorrectComponent,
    AmImageComponent,
    AMPMPipe,
    NgbModule,
    NgOptimizedImage,
    AmBagsTableCarryonComponent,
    AmBagDetailCarryonComponent,
    AmBagPriceCarryonComponent,
    AmBagAddCarryonComponent,
    AmCheckBoxComponent,
    AmBagsFooterResumeComponent,
    Bags20kgOnlyWebAppModalComponent,
    modalRefactorComponent,
    AmStatusPaymentComponent,
    FormErrorMessageComponent,
    AmInputFormComponent,
    AmSelectFormComponent,
    AmDateFormComponent,
    FlightStatusAlertComponent,
    ItineraryAfectedIropsViewComponent,
    ItineraryCanceledIropsViewComponent,
    SubtitleIropsViewComponent,
    TitleIropsViewComponent,
    BannerIropsViewComponent,
    ErrorsModalComponent,
    ErrorsModalDestinationComponent,
    AmpassengerButtonSelectComponent,
    AmpassengerButtonSelectComponent,
    NewFlightInfoIropsViewComponent,
    BannerIropsViewComponent,
    IropsAfectedNoKioskComponent,
    AmFlightInfoBannerComponent,
    AmRowPlaneComponent,
    AmMapPlaneComponent,
    AmFlightItineraryComponent,
    AmScrollDirective,
    AmCalendarComponent,
    AmCalendarItemComponent,
    AmCalendarMonthComponent,
    AmSeatPlaneComponent,
    MagnifyVideoModalComponent,
    LocalizedDatePipe,
    HourTo24FromAMPMDatePipe,
    VerifyPassportModalComponent,
    AmFlightStatusPipe,
    AMCapitalizePipe,
    BannerIropsFlightInfoComponent,
    AmButtonCalendarComponent,
    ModalNoticeCanadaComponent,
    FlightDetailModalComponent,
    IropReviewItineraryComponent,
    SeatUbicationPipe,
    NameInitialsPipe,
    AmFlightSelectItineraryComponent,
    NgbDatepicker,
    AmInputGlobalFormComponent,
    TitleFormAlertComponent,
    AmLabelComponent,
    AmInputSwitchComponent,
    VisaModalComponent,
    AirLinesComponent,
    BannerExclamationComponent,
    ApplyAllPassengersComponent,
    MaskProtectNumberPipe,
    AmWarningCheckInComponent,
    AmLegFlightComponent,
    AmItineraryLegComponent,
    AmGenderPipe,
    ModalFullLoadingComponent,
    AmBagsCounterComponent,
    AmBannerCorporateComponent,
    AmStatusBannerComponent,
    AmFlightStatusScreenComponent,
    ScanpassportModalComponent,
    ModalFullLoadingComponent,
    StepperBagsComponent,
    AmTruncatePipe,
    WeighingComponent,
    WeighingSSBDComponent,
    AmpassengerButtonSelectBagsComponent,
    NeedChairModalComponent,
    AmTruncatePipe,
    AmpassengerButtonSelectFnnComponent,
    AmActionsMenuComponent,
    AmCartItemComponent,
    ModalPassengersPriorityCodeComponent,
    AmPassengerListPriorityCodeComponent,
    AmPassengerListPriorityCodeItemComponent,
    DownloadAppModalComponent,
    FlightStatusAlertRebrandComponent,
    TitleIropsRebrandComponent,
    SubtitleIropsRebrandComponent,
    NewFlightInfoIropsRebrandComponent,
    ItineraryCanceledIropsRebrandComponent,
    ItineraryDelayedIropsRebrandComponent,
    ItineraryEarlyIropsRebrandComponent,
    BannerIropsRebrandComponent,
    IropsDeleteCHKModalComponent,
    QrRefundFlightComponent,
    FlightDataInfoComponent,
    ItineraryNoElegibleComponent,
    BannerNoElegibleComponent,
    BagsRedemptionModalComponent,
    AmPassengerCellCarryOnComponent,
    AmBagCellCarryOnComponent,
    CarryonOfferModalComponent,
    CarryonAddModalComponent,
    TsaBlockerModalComponent,
    ValidHourUndefinedPipe,
    BannerConfirmedFlightAfectedComponent,
    ModalPassengersPriorityCodeComponent,
    AmPassengerListPriorityCodeComponent,
    AmPassengerListPriorityCodeItemComponent,
    DownloadAppModalComponent,
    AmPlaneFareInfoComponent,
    PrinterErrorModalComponent,
    BagtagLowPaperModalComponent,
    BoardingPassLowPaperModalComponent,
    BoardingPassPaperEmptyModalComponent,
    PaymentSimulatorModalComponent,
    PaymentSimulatorAdminComponent,
    EligibilityMessageComponent,
    PrinterErrorModalComponent,
    PlacesAutocompleteComponent,
    HighlightTextPipe,
    EligibilityMessageComponent,
    BaggageTimerComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    StepperBagsSsbdComponent,
    AmToastComponent,
    CobrandBenefitModalComponent,
    AmExperiencePollComponent,
    ExperiencePollModalComponent,
    StepperBagsSsbdComponent,
    AmCurrencyPipe
  ],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgOptimizedImage,
    NgxMaskDirective,
    NgxMaskPipe,
    QRCodeComponent,
  ],
  providers: [MaskProtectNumberPipe, provideNgxMask()],
})
export class SharedModule {}
